import { Component } from '@angular/core';

@Component({
  selector: 'app-cards10-examples-67',
  templateUrl: './cards10-examples-67.component.html'
})
export class Cards10Examples67Component {}
